import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UtilsService } from '../../../shared/utils.service';
import {
  VERIFICATION_DISPLAYS,
  VERIFICATION_LEGEND_ORDER
} from '../users-verification-statuses';

/**
 * Dialog explaining every email verification display shown in the Admin Users list.
 * Reads the same shared metadata as the table and the filter.
 */
@Component({
  selector: 'app-users-verification-legend',
  templateUrl: './users-verification-legend.component.html',
  styleUrls: ['./users-verification-legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UsersVerificationLegendComponent {
  readonly displays = VERIFICATION_DISPLAYS;
  readonly order = VERIFICATION_LEGEND_ORDER;

  constructor(public utils: UtilsService) {}

  /**
   * Replace the {appName} token in legend wording with the white-label app name.
   */
  appText(text: string): string {
    return text.split('{appName}').join(this.utils.getAppName());
  }
}
